require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./company-where-we-work.json") })
        }
      }, "path---company-where-we-work");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---company-where-we-work!./.cache/json/company-where-we-work.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---company-where-we-work!./.cache/json/company-where-we-work.json
// module chunks = 231608221292675